import { Chip } from "@mui/material";
import { type MatchedRow } from "./types";
import { statusText } from "./messages";

// モック（commercial-registry-csv-excel-mock.html）のステータスの配色
const colors: Record<MatchedRow["status"], { bg: string; fg: string }> = {
  NUMBER_MATCHED: { bg: "#e5f4ed", fg: "#237055" },
  AUTO_ASSIGNED: { bg: "#e4f2f6", fg: "#216f82" },
  NEEDS_REVIEW: { bg: "#fff0d9", fg: "#a36115" },
  UNMATCHED: { bg: "#fff0d9", fg: "#a36115" },
  ERROR: { bg: "#fbe6e6", fg: "#b94343" },
  DUPLICATE: { bg: "#efedf8", fg: "#66549b" },
};

/** 照合結果のステータスを色付きのラベルで表示する */
export const StatusChip = ({
  status,
}: {
  status: MatchedRow["status"];
}): JSX.Element => (
  <Chip
    size="small"
    label={statusText[status]}
    sx={{
      minWidth: 74,
      fontWeight: 700,
      bgcolor: colors[status].bg,
      color: colors[status].fg,
    }}
  />
);
